class Blog {
  constructor() {
    let cache = {};
    let initFunc = () => {
      initCache();
      registerEvents();
    }

    let initCache = () => {
      cache.page = document.querySelector('.template-blog');
      cache.categoryButtons = document.querySelectorAll('.category-btn');
      cache.categorySelect = document.querySelector('[data-category-select]');
    };

    let registerEvents = () => {
      initCategoryFilters();
      initCategoryDropdown();
    };

    let initCategoryFilters = () => {
      cache.categoryButtons.forEach(button => {
        button.addEventListener('click', (e) => {
          e.preventDefault();
          const categoryId = button.getAttribute('data-category');
          filterByCategory(categoryId);
        });
      });
    };

    let initCategoryDropdown = () => {
      if (cache.categorySelect) {
        cache.categorySelect.addEventListener('change', (e) => {
          const categoryId = e.target.value;
          filterByCategory(categoryId);
        });
      }
    };

    let filterByCategory = (categoryId) => {
      const currentUrl = new URL(window.location.href);
      
      if (categoryId === '0') {
        currentUrl.searchParams.delete('cat_filter');
      } else {
        currentUrl.searchParams.set('cat_filter', categoryId);
      }
      
      const searchQuery = currentUrl.searchParams.get('s');
      if (searchQuery) {
        currentUrl.searchParams.set('s', searchQuery);
      }
      
      window.location.href = currentUrl.toString();
    };

    initFunc();
  };
}
export { Blog }
